<template lang="html">
  <div class="main-body">
      <!-- 机构统计 -->
      <div class="main-body-search">
        <el-form :inline="true" :model="filters" @submit.native.prevent size="small" label-width="auto">
          <el-form-item>
            <el-select v-model="filters.type" placeholder="机构类别" change="">
              <el-option
                 v-for="item in residentOfficeTypes"
                 :key="item.key"
                 :label="item.value"
                 :value="item.key">
               </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.residentOfficeId" placeholder="机构名称" change="">
              <el-option v-for="item in briefEdition" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item >
            <!-- <el-date-picker v-model="filters.year" type="year" placeholder="选择年份" value-format="yyyy">
            </el-date-picker> -->
            <el-select v-model="filters.year" filterable placeholder="选择年份">
              <el-option v-for="value in yearArray" :key="value" :label="value" :value="value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="aggregationPlanActivityPager()">查询</el-button>
            <el-button type="primary" icon="el-icon-download" @click="aggregationPlanActivityExport()">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--查询列表-->
      <div class="main-body-table">
        <el-table :data="planActivityTableData" style="width: 100%" :height="tableHeight">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="residentOfficeName" label="机构名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="开展活动名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activityType" label="活动类型" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="planHoldingTime" label="计划活动时间" min-width="120" show-overflow-tooltip></el-table-column> <!-- 城市暂定为地区 -->
          <el-table-column prop="actualHoldingTime" label="实际活动时间" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activeAddress" label="活动地址" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="partners" label="合作方" min-width="120" show-overflow-tooltip></el-table-column>
        </el-table>
        <!--工具条-->
        <el-pagination class="main-body-table-page" layout="total, prev, pager, next, jumper"
          @current-change="planActivityHandleCurrentChange"
          :current-page="pager.current" :page-size="pager.size" :total="pager.total">
        </el-pagination>
      </div>
  </div>
</template>

<script>
import {
    selectBriefEdition,
} from '@/views/yourbiz/api/sum/Org';
import {aggregationPlanActivity} from '@/views/yourbiz/api/plan/AggregationPlanActivity';
import dateUtil from '../../../common/js/util';
import {
  download
} from '@/util/http';
export default {
  data() {
    return {
      residentOfficeTypes: [],
      // 固定table高度
      tableHeight: window.innerHeight - 250,
      // 查询过滤条件对象
      filters: {
        type: this.utils.orgCategories[0].key,
        year: new Date().getFullYear().toString()
      },
      // 机构简略信息
      briefEdition: [],
      yearArray:['2019','2020','2021','2022','2023','2024','2025','2026','2027','2028','2029'],
      // 分页对象
      pager: {
        current: 1,
        size: 8,
        total: 0
      },
      // 机构统计 - tableData
      planActivityTableData: []
    }
  },
  mounted() {
    this.findBriefEdition();
    // 默认取 - 获取当前用户可使用的机构类型第一个值
    this.filters.type = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))[0].key
    // 获取当前用户可使用的机构类型
    this.residentOfficeTypes = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))
  },
  methods: {
    // 构简略信息查询
    findBriefEdition() {
      selectBriefEdition().then(result => {
        if(result.code == 20000 && result.data) {
          this.briefEdition = result.data;
        }
      })
    },
    // 机构统计分页查询
    aggregationPlanActivityPager() {
      this.filters.current = this.pager.current;
      this.filters.size = this.pager.size;
      aggregationPlanActivity(this.filters).then(result => {
        if(result.code == 20000 && result.data) {
          this.pager.total = result.total;
          this.planActivityTableData = result.data;
        }
      }).catch(() => {
        return this.$message.error(`数据查询异常`);
      });
    },
    // 计划活动统计导出
    aggregationPlanActivityExport() {
      download("/plan/aggregation/planActivity/export", '计划活动统计表.xls', this.filters);
    },
    // 机构统计分页组件
    planActivityHandleCurrentChange(current) {
      this.pager.current = current;
      this.aggregationPlanActivityPager();
    },
    // 变更类型触发事件
    changeType(type) {
      if(this.utils.orgCategories[2].key == type) {
        this.dict.employeesPost = this.utils.personnelPost;
      }
    },
    // -----------------utils
    // TODO 如果前台要时间动态文件名需要这个方法
    generateFileName(type, tab) {

    }
  }
};
</script>

<style lang="scss"></style>
